import React, { useContext } from 'react'
import { Flex, Text } from 'pcln-design-system'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import TripDetailsBox from './TripDetailsBox'

export default function BookingInfo({
  product,
  date,
  headline,
  subHeadline
}: {
  product: 'hotel' | 'flight' | 'car'
  date: string
  headline: string
  subHeadline: string
}) {
  const {
    customer: { firstName = '' }
  } = useContext(BootstrapDataContext)

  return (
    <Flex
      pt={['24px', 4]}
      pb={[3, 4]}
      px={[3, '24px']}
      flexDirection="column"
      justifyContent="center"
      width={1}
    >
      <Text
        textStyle={['heading3', null, null, null, 'heading2']}
        mb={2}
        color="text.heading"
        className={firstName ? 'fs-mask' : ''}
      >
        {firstName ? `${firstName}, your` : 'Your '} trip is coming up!
      </Text>
      <Text textStyle="subheading5" color="text.light" mb="24px">
        {date}
      </Text>
      <TripDetailsBox
        product={product}
        headline={headline}
        subHeadline={subHeadline}
      />
    </Flex>
  )
}
